var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { BaseReportItemComponent } from 'app/reports/models/base-report-item-component';
var TextItemComponent = /** @class */ (function (_super) {
    __extends(TextItemComponent, _super);
    function TextItemComponent() {
        return _super.call(this) || this;
    }
    TextItemComponent.prototype.ngOnInit = function () {
    };
    TextItemComponent.prototype.ngAfterViewInit = function () {
        _super.prototype.ngAfterViewInit.call(this);
    };
    TextItemComponent.prototype.setReportData = function (data, results, variables) {
        this.data = data;
    };
    return TextItemComponent;
}(BaseReportItemComponent));
export { TextItemComponent };



// WEBPACK FOOTER //
// ./src/app/reports/text-item/text-item.component.ts.pre-build-optimizer.js